import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deviceInitialState } from './state';
import { IDevice } from './types';

export const deviceSlice = createSlice({
  name: 'device',
  initialState: deviceInitialState,
  reducers: {
    setDevice: (state, action: PayloadAction<IDevice>) => {
      state = action.payload;
      return state;
    },
  },
});
